var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('loading-overlay',{attrs:{"active":_vm.app.loading,"is-full-page":true,"can-cancel":false,"color":'#000',"background-color":'#192028',"opacity":0.25,"loader":"dots"}}),_c('router-view')],1),_c('MainAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }